import { AuthConfigService } from './auth-config.service';
import { AuthService } from './auth.service';

export const appInitializerFactory = (authConfigService: AuthConfigService, authService: AuthService) => {
    return async () => {
        await authConfigService.loadAuthConfig();
       return authService.runInitialLoginSequence();
    };
};
